import { getApi } from '../utils/api';
import { API_ENDPOINTS } from '../utils/endpoints';
import { log, logError } from '../utils/logger';
import { APP_VERSION } from '../utils/version';

class VersionService {
  async combineVersion(uiVersion) {
    try {
      const api = getApi();
      const response = await api.post(API_ENDPOINTS.VERSION.COMBINE, {
        ui_version: uiVersion
      });
      
      log('Version combine successful:', {
        uiVersion,
        response: response.data
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      logError(error, 'Version combine failed', {
        uiVersion,
        endpoint: API_ENDPOINTS.VERSION.COMBINE
      });
      
      return {
        success: false,
        error: error.message || 'Failed to combine version'
      };
    }
  }

  getCurrentVersion() {
    // Get version directly from version utility
    return APP_VERSION;
  }
}

export const versionService = new VersionService();
export default versionService; 